import { ValueLabel } from "@features/ax/shared/ValueLabel";

export const SummaryCard = ({ data }: { data?: any }) => {
  const meterCycle = data?.meterSchedule?.meterCycle;
  const items = [
    { label: "READ CYCLE ID", value: data?.id ?? "NA" },
    { label: "READ CYCLE NAME", value: meterCycle?.meterCycleName ?? "NA" },
    { label: "MONTH", value: data?.month ?? "NA" },
    { label: "READING PERIOD", value: `${data?.startDate ?? "NA"} - ${data?.endDate ?? "NA"}` },
    { label: "ROUTE STATUS", value: data?.status ?? "NA" },
  ];

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        {items.map((item, idx) => (
          <ValueLabel
            key={idx}
            label={item.label}
            value={ item.value}
            layout="vertical"
          />
        ))}
      </div>

      <p className="text-xs text-muted-foreground mt-3">
        The performance metrics below correspond to the latest run of the read
        cycle this route belongs to.
      </p>
    </div>
  );
};
